import ArticleTemplate from '@/components/feature/ArticleTemplate';
import { allArticles } from '@/mocks/articles';

const article = allArticles.find((a) => a.slug === 'vigorbuy-spreadsheet-vs-excel')!;

export default function ArticleVsExcelPage() {
  return <ArticleTemplate article={article} />;
}